/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import { AppBar, Hidden, IconButton, Toolbar, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

import SizeSoftXLogoMain from "../../img/sizesoftx-logo-1-20.svg";
import { useLayout } from "../../context/System/LayoutContext";
import { useSesion } from "../../context/System/SesionContext";

export default function SizeSoftXAppBar() {
  const {
    configuracion: { tituloDependencia },
  } = useSesion();
  
  const { handleOpenMenuClient, menuDashboardOpen, handleOpenMenuDashboard, handleCloseMenuDashboard } = useLayout();

  return (
    <AppBar position="static" color="transparent" variant="elevation" style={{ overflowX: "auto" }}>
      <Toolbar variant="dense" style={{ marginTop: 2, marginBottom: 2, backgroundColor:'orange' }}>
        <Hidden lgUp>
          <IconButton color="primary" sx={{ marginRight: 2}} onClick={handleOpenMenuClient}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          {menuDashboardOpen ? (
            <Tooltip title="Ocultar menú">
              <IconButton color="primary" sx={{ marginRight: 2, backgroundColor:'white'}} onClick={handleCloseMenuDashboard}>
                <MenuOpenIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Mostrar menú">
              <IconButton color="primary" sx={{ marginRight: 2, backgroundColor:'white' }} onClick={handleOpenMenuDashboard}>
                <MenuIcon />
              </IconButton>
            </Tooltip>
          )}
        </Hidden>
        <Hidden smDown>
          <div style={{ flexGrow: 1 }}>
            <img
              src={SizeSoftXLogoMain}
              alt={tituloDependencia}
              title={tituloDependencia}
              style={{ height: 60, marginLeft: 20, marginRight: 20, marginTop:10}}
            />
          </div>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}
